module.exports = __webpack_public_path__ + "static/media/particular-company.94f0e324.svg";